import { useState } from 'react';
import { calculateTotalCost, checkAvailability } from './bookingUtils';
import { format } from 'date-fns';

export const useBookingForm = (dateRange: { startDate: Date | null, endDate: Date | null }) => {
    const [availability, setAvailability] = useState<any[] | null>(null);
    const [availabilityError, setAvailabilityError] = useState<string>('');
    const [selectedPackages, setSelectedPackages] = useState<any[]>([]);
    const [totalCost, setTotalCost] = useState<number>(0);
    const [arrivalDate, setArrivalDate] = useState<string | null>(null);
    const [departureDate, setDepartureDate] = useState<string | null>(null);

    const handleCheckAvailability = async (packageId: number) => {
        console.log('Checking availability for package:', packageId);
        try {
            if (dateRange.startDate && dateRange.endDate) {
                const availabilityData = await checkAvailability(packageId, { startDate: dateRange.startDate, endDate: dateRange.endDate });
                if (availabilityData) {
                    setAvailability(Array.isArray(availabilityData) ? availabilityData : []);
                    console.log('Availability data:', availabilityData);
                    if (Array.isArray(availabilityData) && availabilityData.length === 0) {
                        setAvailabilityError('No campsites available for the selected dates.');
                    } else {
                        setAvailabilityError('');
                        const formattedArrivalDate = format(dateRange.startDate, "yyyy-MM-dd'T'HH:mm:ssXXX");
                        const formattedDepartureDate = format(dateRange.endDate, "yyyy-MM-dd'T'HH:mm:ssXXX");
                        setArrivalDate(formattedArrivalDate);
                        setDepartureDate(formattedDepartureDate);
                        console.log('Arrival date:', formattedArrivalDate);
                    }
                } else {
                    setAvailabilityError('No availability data returned.');
                }
            } else {
                setAvailabilityError('Invalid date range.');
            }
        } catch (error: any) {
            setAvailabilityError(error.message);
        }
    };

    const handleSelectPackage = (site: any) => {
        const isSelected = selectedPackages.some(pkg => pkg.id === site.id);
        let updatedPackages = [];

        if (isSelected) {
            updatedPackages = selectedPackages.filter(pkg => pkg.id !== site.id);
        } else {
            updatedPackages = [...selectedPackages, site];
        }

        setSelectedPackages(updatedPackages);
        const totalCost = calculateTotalCost(updatedPackages, dateRange);
        setTotalCost(totalCost);
    };

    return {
        availability,
        availabilityError,
        selectedPackages,
        totalCost,
        arrivalDate,
        departureDate,
        handleCheckAvailability,
        handleSelectPackage,
    };
};